module.exports = __webpack_public_path__ + "static/integrations-balloons-c867bb2fa42f4e344c9aefc1dba739bd.png";